module.exports = {
      id: "success-circle-usage",
      viewBox: "0 0 89 88",
      url: __webpack_public_path__ + "svg-sprite-9bf32fda02e4f885c0073d291388af8d.svg#success-circle",
      toString: function () {
        return this.url;
      }
    }